import type { IChatUserSummary } from "@/types/(my-space)/chat.interface";

/**
 * A person shown in the profile popup as if their direct chat: their picture
 * and name. `id` is the person's id (the popup hands it back to Message).
 */
export const personProfile = (user: IChatUserSummary) => ({
  id: user.id,
  type: "direct" as const,
  name: null,
  imageUrl: null,
  metadata: null,
  isSelf: false,
  peer: user,
});
